import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "react-feather";
import { STAFF_AVAILABILITY_LOCKED_MESSAGE } from "../../utils/authHelper";

const StaffAvailabilityLockedPage = () => {
  return (
    <section className="staff-availability-locked-page">
      <div className="staff-availability-locked-card">
        <Lock size={48} />
        <h1>Availability Access Disabled</h1>
        <p>{STAFF_AVAILABILITY_LOCKED_MESSAGE}</p>
        <Link to="/staff/dashboard" className="btn btn-app">
          Back to Dashboard
        </Link>
      </div>
    </section>
  );
};

export default StaffAvailabilityLockedPage;
